import GetReportSubStatusList from "hooks/ReportSubStatus/GetReportSubStatusList";
import { useSnackbar } from "notistack";

import { useEffect, useState } from "react";
import TLinkApi from "services/tlink.api";

const GetReportHistoryList = () => {
  const enqueueSnackbar = useSnackbar();
  const [reportHistory, setReportHistory] = useState([]);
  const [reportHistoryMap, setReportHistoryMap] = useState();
  const [page, setPage] = useState(0);
  const [totalLength, setTotalLength] = useState(0);
  const [search, setSearch] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [entriesPerPage, setEntriesPerPage] = useState(50);
  const [sortBy, setSortBy] = useState("jobId");
  const [sortOrder, setSortOrder] = useState("asc");

  const GetReportHistory = async () => {
    try {
      setIsLoading(true);
      let data = await TLinkApi.get(
        `/reports/history?search=${search}&page=${
          Number(page) + 1
        }&limit=${entriesPerPage}&sortOrder=${sortOrder}&sortBy=${sortBy}`
      );
      setReportHistory(data.data.reportData);
      setTotalLength(data.data.totallength);
      setIsLoading(false);
      let reportHistoryMap = [];
      data?.data?.reportData.map((value) => {
        reportHistoryMap[value.id] = value.name;
        return true;
      });
      setReportHistoryMap(reportHistoryMap);
    } catch (e) {
      setIsLoading(false);
      enqueueSnackbar(
        e?.response?.data?.result?.userMessage ||
          "An unexpected error occurred on the server while processing the request!!!"
      );
    }
  };

  useEffect(() => {
    const delayDebounceFn = setTimeout(() => {
      GetReportHistory();
    }, 500);
    return () => clearTimeout(delayDebounceFn);
  }, [page, entriesPerPage, sortBy, sortOrder, search]);

  return {
    reportHistory,
    setReportHistory,
    reportHistoryMap,
    isLoading,
    totalLength,
    setIsLoading,
    setPage,
    page,
    setSearch,
    search,
    setEntriesPerPage,
    entriesPerPage,
    setSortOrder,
    setSortBy,
    sortBy,
    sortOrder,
  };
};

export default GetReportHistoryList;
